import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { getActiveSite } from "../../selectors/sites.js";
import { useAppSelector } from "../../store/hooks.js";
import styles from "../../stylesheets/components/header-mobile/mobile-language-menu.module.css";
import { Language } from "../../types/index.js";
import { getLanguageMenuItems } from "../../utils/utils.js";
import SmartLink from "../SmartLink.js";

interface Props {
  className: string;
  isPreview: boolean;
  languageId: Language;
  pageId: string;
  onClick: () => void;
}

const MobileLanguageMenu: FunctionComponent<Props> = ({
  isPreview,
  languageId,
  onClick,
  className,
  pageId,
}) => {
  const site = useAppSelector((state) => getActiveSite(state.sites));
  const pages = useAppSelector((state) => state.pages);
  const items = getLanguageMenuItems({
    isPreview,
    pageId,
    pages,
    siteLanguages: site.languages,
    useFullLanguageNames: false,
  });

  return items.length > 1 ? (
    <ul className={ClassNames(styles.MobileLanguageMenu, className)}>
      {items.map(({ children, href, hrefLang, rel }) => (
        <li
          key={hrefLang}
          className={ClassNames({
            [styles["MobileLanguageMenu__ListItem--active"]]:
              hrefLang === languageId,
          })}
        >
          <SmartLink
            isPreview={isPreview}
            anchorAttrs={{
              rel,
              hrefLang,
              href,
              className: styles.MobileLanguageMenu__Item,
              onClick,
            }}
          >
            {children}
          </SmartLink>
        </li>
      ))}
    </ul>
  ) : null;
};

export default MobileLanguageMenu;
